import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import createDOMPurify from "dompurify";

import { ChapterElementProps } from "./types";
import { getEvidenceTitle } from "@/domains/evidence/hooks/useEvidenceFields";

const ChapterElement = ({ value }: ChapterElementProps) => {
  const { title, text, attachedBlocks } = value;
  const { t } = useTranslation();
  const DOMPurify = createDOMPurify(window);

  return (
    <div className="chapter-element body-m-regular">
      <div className="body-m-medium">{title}</div>
      {text && (
        <div
          style={{ wordWrap: "break-word" }}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(text, {
              USE_PROFILES: { html: true },
            }),
          }}
        />
      )}

      {attachedBlocks?.length > 0 && (
        <>
          <p className="body-m-medium">
            {t("datablocks.labels.attachedEvidenceLabel")}
          </p>
          <ul>
            {attachedBlocks.map((block) => (
              <li key={block.id}>
                <Link to={`/evidence/${block.id}`}>
                  {getEvidenceTitle(block)}
                </Link>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default ChapterElement;
